
import { Component, Vue } from "vue-property-decorator";
import { submitProgrammaticForm } from "@/helpers/forms";

@Component
export default class ExternalAuthHandler extends Vue {
  // Methods

  /**
   * @name redirectToExternalUrl
   * @desc Here we redirect to an external URL (eg Stripe) and intentionally do
   * NOT resolve the function promise, ensuring the payment processing state
   * remains unchanged whilst the page offloads
   */

  public redirectToExternalUrl({ url, method, fields = {} }) {
    if (!fields) fields = {};
    return new Promise<void>(() => {
      url = new URL(url);
      url.searchParams.forEach((v, k) => (fields[k] = v));
      submitProgrammaticForm({
        url: [url.origin, url.pathname].join(""),
        method,
        fields
      });
    });
  }
}
